import { unref } from 'vue';

import type {
  ContextMenuItem,
} from '../components/general/CommonContextMenu/CommonContextMenuItem.vue';

export function resolveVisibleContextMenuItems<T>(items: ContextMenuItem<T>[]) {
  return items.filter((i) => {
    if (i.items?.length) return i.items?.some((j) => unref(j.visible) !== false) && unref(i.visible) !== false;
    return unref(i.visible) !== false;
  });
};
